import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ elementId, elementType, projectId }) =>
    present(
      repository
        .retrieveElementAttachments(elementId, elementType, projectId)
        .catch(() => Promise.reject(elementId)),
    );
}

export type { Interactor };

export { createInteractor };
